// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(hover: hover)and (pointer: fine){.hoverable:hover{opacity:.8;transition:opacity .125s ease-out}}", "",{"version":3,"sources":["webpack://components/Hoverable/index.scss"],"names":[],"mappings":"AAAA,wCACE,iBACE,UAAA,CACA,iCAAA,CAAA","sourcesContent":["@media (hover: hover) and (pointer: fine) {\n  .hoverable:hover {\n    opacity: 0.8;\n    transition: opacity 0.125s ease-out;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
